import React from "react";
import "../style/kontakt.css";

const osobyKontaktowe = [
  {
    imie: "Krzysztof Czernek",
    telefon: "+48 607-109-070",
    email: "k.czernek@kompland.com.pl",
  },
  {
    imie: "Łukasz Sporek",
    telefon: "+48 601-448-554",
    email: "l.sporek@kompland.com.pl",
  },
  {
    imie: "Dawid Umiński",
    telefon: "+48 601-497-000",
    email: "d.uminski@kompland.com.pl",
  },
  {
    imie: "Przemysław Biernat",
    telefon: "+48 730-953-555",
    email: "p.biernat@kompland.com.pl",
  },
];

const Kontakt = () => {
  return (
    <main className="kontakt-main">
      <h2>Kontakt</h2>
      <div className="kontakt-cards">
        {osobyKontaktowe.map((osoba, index) => (
          <div className="kontakt-card" key={index}>
            <h3>{osoba.imie}</h3>
            <p>
              <strong>Telefon:</strong>{" "}
              <a href={`tel:${osoba.telefon.replace(/[\s-]/g, "")}`}>
                {osoba.telefon}
              </a>
            </p>
            <p>
              <strong>E-mail:</strong>{" "}
              <a href={`mailto:${osoba.email}`}>{osoba.email}</a>
            </p>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Kontakt;
